import React from 'react';
import Header from './Header';
import HeaderApp from './HeaderApp';

export default function HeaderResp({refFooter}) {
  return (
    window.innerWidth > 500 ? <Header refFooter={refFooter} /> : <HeaderApp refFooter={refFooter} />
  )
}
